<template>
  <div style="height: 100%">
    <div class="btn-upload">
      <el-button
        size="mini"
        v-auth="['Company', 'DealWith']"
        @click="$refs.uploadFile.visible = true"
        >上传<i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </div>
    <!-- <a-table bordered :resizeable="true" :pagination="false" :rowKey="(record) => record.id" :columns="columns"
      :data-source="tableData" :scroll="{ y: 250 }">
      <div slot="actions" slot-scope="text, record" v-auth="'Company'">
        <el-button type="text" style="color: #f56c6c" size="mini" @click="deleteRow(record.id)">删除</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button type="text" size="mini" @click="previewFileHandle(record)">预览</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button type="text" size="mini" @click="downloadFile(record)"> 下载</el-button>
      </div>
    </a-table> -->
    <el-table
      :header-cell-style="{
        background: '#f5f5f5',
      }"
      :data="tableData"
      height="calc(100% - 70px)"
      border
      style="width: 100%"
    >
      <el-table-column align="center" label="序号" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" prop="name" label="文件名称">
      </el-table-column>
      <el-table-column align="center" prop="size" label="文件大小（MB）">
        <template slot-scope="{ row }">
          {{ (row.size / 1048576).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createdTime" label="上传时间">
      </el-table-column>

      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            v-auth="['DealWith', 'Company']"
            style="color: #f56c6c"
            size="mini"
            @click="deleteRow(row.id)"
            >删除</el-button
          >
          <el-button type="text" size="mini" @click="previewFileHandle(row)"
            >预览</el-button
          >
          <el-button type="text" size="mini" @click="downloadFile(row)">
            下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <uploadFile
      @getData="getList()"
      ref="uploadFile"
      :url="$api[type].upload"
      :isShowName="true"
      :accept="accept"
    >
    </uploadFile>
    <previewFile
      ref="previewFile"
      :fileUrl="fileUrl"
      :tabView="tabView"
      :fileName="fileName"
    ></previewFile>
    <el-dialog :title="fileName" :visible.sync="imgVisible">
      <img width="100%" height="100%" :src="fileUrl" v-if="imgVisible" />
    </el-dialog>
  </div>
</template>

<script>
import uploadFile from "@/components/uploadFile";
import previewFile from "./previewFile.vue";
import { DownloadBlob } from "@/http/downloadService";

export default {
  components: { uploadFile, previewFile },
  props: {
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    const columns = [
      {
        title: "序号",
        align: "center",
        width: 70,
        customRender: (text, record, index) => {
          return index + 1;
        },
      },
      { title: "文件名称", dataIndex: "name", key: "name", align: "center" },
      {
        title: "文件大小（MB）",
        dataIndex: "size",
        key: "size",
        align: "center",
        customRender: (text, record, index) => {
          return (text / 1048576).toFixed(2);
        },
      },
      {
        title: "上传时间",
        dataIndex: "createdTime",
        key: "createdTime",
        align: "center",
        customRender: (text, record, index) =>
          this.$dayjs(record.createdTime).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: "操作",
        key: "operation",
        fixed: "right",
        width: 160,
        align: "center",
        scopedSlots: { customRender: "actions" },
      },
    ];
    return {
      imgVisible: false,
      columns,
      tableData: [],
      fileUrl: "",
      tabView: "",
      fileName: "",
      // companyId:
      accept: ".xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png",
    };
  },

  computed: {
    companyId() {
      return this.$store.state.companyId;
    },
  },
  watch: {
    companyId(val) {
      this.getList();
    },
  },
  methods: {
    getList() {
      let url = this.$api[this.type].getList;
      let params = {};
      const companyId = this.companyId; //.$store.state.companyId;
      if (companyId) params.companyId = companyId;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { list } = res.data.data;
          this.tableData = list;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    deleteRow(id) {
      this.$confirm("此操作将永久删除此项, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let url = this.$api[this.type].delete + "/" + id;

        this.$axios.del(url, false).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      });
    },
    previewFileHandle(row) {
      let baseUrl = process.env.VUE_APP_BASEURL;
      let url = this.$api[this.type].download + "/" + row.guid;

      let hz = row.name.substring(row.name.lastIndexOf(".") + 1);

      let isPrevire = true;
      switch (hz) {
        // case "doc":
        case "docx":
          this.tabView = "VueOfficeDocx";
          break;

        // case "xls":
        case "xlsx":
          this.tabView = "VueOfficeExcel";

          break;

        case "pdf":
          this.tabView = "VueOfficePdf";
          break;

        case "jpg":
        case "png":
          this.imgVisible = true;
          break;
        default:
          isPrevire = false;
          break;
      }

      // switch (hz) {
      //   case "doc":
      //   case "docx":
      //   case "xls":
      //   case "xlsx":
      //   case "ppt":
      //   case "pptx":
      //     //使用在线office预览

      //     break;
      //   case "pdf":
      //     this.tabView = 'VueOfficePdf'
      //     break;
      //   case "jpg":
      //   case "jgeg":
      //   case "png":
      //     this.imgVisible = true;
      //     break;
      //   default:
      //     isPrevire = false;
      //     break;
      // }
      if (!isPrevire) {
        this.$message("当前文件格式暂不支持预览。");
        return;
      }
      this.fileName = row.name;
      this.fileUrl = baseUrl + url;
      if (!this.imgVisible) this.$refs.previewFile.visible = true;
    },
    downloadFile(row) {
      let url = this.$api[this.type].download + "/" + row.guid;

      DownloadBlob({
        url: url,
        method: "get",
      });
    },
    getListByCompanyId(companyId) {
      this.companyId = companyId;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  activated() {
    // this.getList();
  },
};
</script>

<style lang="scss" scoped>
.btn-upload {
  margin: 5px 0px;
}
</style>